import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/contexts/PermissionContext';

export function useOnboardingAccess() {
  const { user } = useAuth();
  const { hasPermission, loading } = usePermissions();

  // Access follows the standard permission system: any role granted
  // view_onboarding_pipeline can see the Internal section. Superadmin-tier
  // permissions keep working as an override, matching the rest of the app.
  const hasAccess =
    !!user &&
    (hasPermission('view_onboarding_pipeline') ||
      hasPermission('system.override') ||
      hasPermission('tenant.manage'));

  return { hasAccess, loading: !user ? false : loading };
}
